import React from "react"
import styled from "styled-components"
import { media, setRem, setColor, setLetterSpacing } from "../../../style"
import socialIcons from "../../../constants/social-icons"
import links from "../../../constants/links"
import { useStaticQuery, graphql } from "gatsby"
import Image from "gatsby-image"
import { useIntl, Link, FormattedMessage } from "gatsby-plugin-intl"

function Copyright() {
  return (
    <div>
      <FormattedMessage id="global.footer.allRights" />{" "}
      {new Date().getFullYear()} FRIDA TRAVEL
    </div>
  )
}

const getImage = graphql`
  query {
    fridaLogo: file(relativePath: { eq: "frida-travel-no-background.png" }) {
      childImageSharp {
        fluid(maxWidth: 140, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`

const Footer = () => {
  const data = useStaticQuery(getImage)
  const intl = useIntl()

  return (
    <Container>
      <div className="cell first-cell">
        <Image
          fluid={data.fridaLogo.childImageSharp.fluid}
          className="logo-frida"
        />
        <div className="social-icon">
          {socialIcons.map((item, index) => {
            return (
              <a
                key={index}
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {item.icon}
              </a>
            )
          })}
        </div>
        <div className="toll-free">
          <FormattedMessage id="global.footer.tollFree" />{" "}
        </div>
        <Link href="tel: 1 888 987 2977" variant="h6" color="textSecondary">
          1 888 987 2977
        </Link>
      </div>

      <div className="cell">
        <h4><FormattedMessage id="global.footer.quickLinks" /> </h4>
        {links.map((item) => {
          return (
            <div key={item.id} className="quick-links">
             
              <Link to={item.path} className={item.class}>
                {intl.formatMessage({id: item.id})}
              </Link>

            </div>
          )
        })}
        {/* <h4>Contact Center</h4>
        Av. Camarón Sábalo 811 Zona Dorada <br />
        Mazatlan, Sinaloa Mexico 82110. */}
      </div>

      <div className="cell">
        <h4><FormattedMessage id="global.footer.ourMission" /> </h4>

        <div>
          <FormattedMessage id="global.footer.provideHigh" />
        </div>
        <br />
        <Copyright />
      </div>
    </Container>
  )
}

export default Footer

const Container = styled.div`
  box-shadow: 2px -2px 5px 0px rgba(133, 126, 133, 1);
  display: grid;
  grid-template-columns: 1fr;
  grid-column-gap: ${setRem(20)};
  padding: ${setRem(20)};
  margin-top: ${setRem(2)};
  ${media.tablet`  
  grid-template-columns: 1fr 1fr 1fr;

  background-color: ${setColor.mainWhite};
    ${setLetterSpacing};
    color: ${setColor.mainGrey};
  `}

  .logo-frida {
    width: 140px;
    margin: auto;
    margin-bottom: 10px;
  }

  .cell {
    padding: 1rem;
    border-left: 1px solid #e0e1e0;
  }
  .first-cell {
    border-left: none;
    text-align: center;
  }
  .social-icon {
    padding: ${setRem(4)};
    a {
      font-size: ${setRem(30)};
      color: ${setColor.mainGrey};
      ${setLetterSpacing(4)};
      margin-right: ${setRem(4)};
    }
  }
  .toll-free {
    color: ${setColor.primaryColor};
    font-weight: bold;
    font-size: ${setRem(15)};
    text-transform: uppercase;
  }
  h4 {
    color: ${setColor.secondaryColor};
    text-transform: uppercase;
    font-size: ${setRem(15)};
    margin-bottom: ${setRem(5)};
    margin-top: ${setRem(10)};
  }

  .quick-links {
    margin: 0;
    a {
      color: ${setColor.mainGrey};
      font-size: ${setRem(13)};
      text-transform: uppercase;
    }
    color: ${setColor.mainGreyGrey};
  }
`
